export default __webpack_public_path__ + "static/media/bizz_mobile.fb82946a.svg";